import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex); 
const state = {   //要设置的全局访问的state对象
    currentUser: sessionStorage.getItem('user') ? sessionStorage.getItem('user') : '',  
    //要设置的初始属性值
    currentQty:sessionStorage.getItem('qty'),
};
const getters = {   //实时监听state值的变化(最新状态)
    getcurrentUser(state) {  //获取当前登录的用户
        return state.currentUser
    }, 
    getcurrentQty(state){
        return state.currentQty
    }
};
const mutations = { 
    setcurrentUser(state, user) {  //同上  
        state.currentUser = user; 
    },
    setcurrentQty(state, qty) {  //同上  
        state.currentQty = qty; 
    },
};
const actions = {
    setUser(context, user) {  //自定义触发mutations里函数的方法，context与store 实例具有相同方法和属性  
        context.commit('setcurrentUser',user);
    }, 
    setQty(context, qty){
        context.commit('setcurrentQty',qty)
    }
};
const store = new Vuex.Store({
    state,
    getters,
    mutations,
    actions,
}); 
export default store;



// WEBPACK FOOTER //
// ./src/store/index.js